<template>
  <v-app>
    <v-main>
      <router-view v-if="!error" :mode="mode" :first-visitor="firstVisitor" />
      <v-container v-else>
        <v-layout columns fill-height align-center>
          {{ error.status }}
          <p>{{ error.message }}</p>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'App',
  data: () => ({
    error: null,
  }),
  computed: {
    ...mapGetters(['loggedIn', 'mode']),

    firstVisitor() {
      if (this.$route.query.first) return true
      return false
    },
  },
  provide() {
    return {
      $error: this.$error,
    }
  },
  methods: {
    ...mapActions(['clear']),
    logout() {
      this.clear()
      this.$router.push('/login')
    },
    $error({ status, message }) {
      this.error = { status, message }
    },
  },
}
</script>
